// extracted by mini-css-extract-plugin
export default {"section":"BurgerIngredients_section__qU3tq","section_ingredients":"BurgerIngredients_section_ingredients__7zeQc","div_tabs":"BurgerIngredients_div_tabs__0FLzP"};